import * as React from 'react';
import { createTheming } from 'react-jss';
export const ThemeContext = /*#__PURE__*/React.createContext({
  scale: 1,
  foregroundColor: 'rgb(255,255,255)',
  labelColor: 'rgb(255,255,255)',
  backgroundColor: 'rgb(0,0,0)',
  dragOver: {}
}); // Creating a namespaced theming object.

const theming = createTheming(ThemeContext); // Note that `useTheme` here comes from the `theming` object, NOT from `react-jss` import.

export const ThemeProvider = theming.ThemeProvider;
export const useTheme = theming.useTheme;
//# sourceMappingURL=Theme.js.map